var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leads"},_vm._l((_vm.leads),function(lead){return _c('Lead',{key:lead.id,attrs:{"lead":lead,"offerLeadStatus":_vm.offerLeadStatus,"tags":_vm.tags}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2c166de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prospection/Cards/LeadsCard.vue
// module id = null
// module chunks = 